import { render, staticRenderFns } from "./change-badge.vue?vue&type=template&id=37d2c7fc&scoped=true&"
import script from "./change-badge.vue?vue&type=script&lang=js&"
export * from "./change-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2c7fc",
  null
  
)

export default component.exports